import logo from '../assets/logo_ekynair.png';
import React, { useState } from 'react';
import { BRAND } from '../constants/theme';
import { mainLine, tooltipTitle } from '../shared/buildInfo';

const ForgotPassword = ({ onBackToLogin, darkMode }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const response = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (data.success) {
        setMessage({ type: 'success', text: 'Si cet email existe, un lien de réinitialisation a été envoyé' });
        setResetSent(true);
      } else {
        setMessage({ type: 'error', text: `${data.message}` });
      }
    } catch (error) {
      setMessage({ type: 'error', text: `Erreur lors de l'envoi` });
    } finally {
      setLoading(false);
    }
  };

  const cardStyle = {
    background: darkMode ? '#1E1E32' : '#fff',
    padding: '40px',
    borderRadius: '12px',
    border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid #e0e0e0',
    boxShadow: darkMode ? 'none' : '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '450px',
    margin: '0 auto',
    width: '100%'
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    borderRadius: '6px',
    border: darkMode ? '1px solid rgba(255,255,255,0.2)' : '1px solid #ddd',
    background: darkMode ? '#282845' : '#fff',
    color: darkMode ? '#E1E1E1' : '#2C3E50',
    fontSize: '14px',
    marginBottom: '20px'
  };

  const buttonStyle = {
    width: '100%',
    padding: '14px',
    background: loading ? '#999' : BRAND.gradient,
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: loading ? 'not-allowed' : 'pointer',
    marginBottom: '16px'
  };

  const linkStyle = {
    color: darkMode ? '#80DEEA' : '#2C3E50',
    textDecoration: 'none',
    cursor: 'pointer',
    fontSize: '14px'
  };

  return (
    <div style={{ padding: '40px 20px', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={cardStyle}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img src={logo} alt="EkynAir" style={{ height: '80px', marginBottom: '12px' }} />
          <h2 style={{ color: darkMode ? '#E8EDF2' : '#2C3E50', fontSize: '20px', marginBottom: '8px', fontFamily: "'Poppins', sans-serif" }}>
            Mot de passe oublié
          </h2>
          <p style={{ color: darkMode ? '#E8EDF2' : '#4A5568', fontSize: '14px' }}>
            {resetSent 
              ? 'Instructions envoyées par email'
              : 'Saisissez votre email pour recevoir un lien de réinitialisation'
            }
          </p>
        </div>

        {message && (
          <div style={{
            padding: '12px',
            borderRadius: '6px',
            marginBottom: '20px',
            background: message.type === 'success' 
              ? (darkMode ? 'rgba(76, 175, 80, 0.2)' : '#e8f5e9')
              : (darkMode ? 'rgba(244, 67, 54, 0.2)' : '#ffebee'),
            color: message.type === 'success'
              ? (darkMode ? '#81c784' : '#2e7d32')
              : (darkMode ? '#ef5350' : '#c62828'),
            border: `1px solid ${message.type === 'success' ? '#4caf50' : '#f44336'}`
          }}>
            {message.text}
          </div>
        )}

        {!resetSent ? (
          <form onSubmit={handleSubmit}>
            <div>
              <label style={{ display: 'block', marginBottom: '6px', color: darkMode ? '#E8EDF2' : '#4A5568', fontSize: '14px' }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="votre.email@exemple.com"
                style={inputStyle}
                required
              />
            </div>

            <button type="submit" style={buttonStyle} disabled={loading}>
              {loading ? 'Envoi...' : 'Envoyer le lien'}
            </button>
          </form>
        ) : (
          <div style={{
            background: darkMode ? 'rgba(255,255,255,0.05)' : '#f0f9ff',
            padding: '16px',
            borderRadius: '6px',
            marginBottom: '20px',
            fontSize: '14px',
            color: darkMode ? '#E8EDF2' : '#4A5568'
          }}>
            <p style={{ marginBottom: '8px' }}>
              Un email a été envoyé à <strong>{email}</strong>
            </p>
            <p style={{ marginBottom: '8px' }}>
              Vérifiez votre boîte de réception et cliquez sur le lien pour réinitialiser votre mot de passe.
            </p>
            <p style={{ fontSize: '12px', color: darkMode ? '#E8EDF2' : '#999' }}>
              Si vous ne recevez pas l'email, vérifiez votre dossier spam.
            </p>
          </div>
        )}

        <div style={{ textAlign: 'center', paddingTop: '20px', borderTop: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid #e0e0e0' }}>
          <span onClick={onBackToLogin} style={{ ...linkStyle, fontWeight: '600' }}>
            ← Retour à la connexion
          </span>
        </div>

        <div title={tooltipTitle} style={{ textAlign: 'center', paddingTop: '20px', color: darkMode ? '#E8EDF2' : '#4A5568', fontSize: '12px' }}>
          {mainLine}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
